import { ITableResponse } from '@tools/ui/types';
import { Scalars, Task } from '@tools/ui/types/generated/graphql';
import { axios as api } from './api';

const routePrefix = '/tasks';

const getAllTasks = async (
  page = 1,
  limit = 10
): Promise<ITableResponse<Task>> => {
  return api.get(routePrefix, { params: { page, limit } });
};

const updateTask = async (task: Task): Promise<ITableResponse<Task>> => {
  return api.post(routePrefix, task);
};

const sendTaskRead = async (taskId: Scalars['MongoID']): Promise<void> => {
  return api.post(`${routePrefix}/task-read`, { _id: taskId });
};

const unreadTask = async (taskId: Scalars['MongoID']): Promise<void> => {
  return api.post(`${routePrefix}/unread-task`, { _id: taskId });
};

const updateTaskLabel = async (): Promise<void> => {
  return api.post(`${routePrefix}/update-label`);
};

export { getAllTasks, updateTask, sendTaskRead, unreadTask, updateTaskLabel };
